export const OWNERSHIP_DECIMAL_PLACES = 8;
export const PERCENTAGE_DIFFERENCE_DECIMAL_PLACES = 6;
export const SHAPE_SIMILARITY_DECIMAL_PLACES = 2;
